import React, { Context, ReactElement, Component, useState } from 'react';
import { operation_type } from '../../../components/new-table-list/interface';
export interface item_type {
  id?: string;
  company?: string;
  restore_start_time?: string;
  db_backup_id?: string;
  db_backup?: {
    id?: string,
    name?: string
  },
  instance?: {
    id?: string,
    name?: string
  }
  instance_id?: string,
  service?: string,
  selected_database?: string,
  db_storage?: {
    id?: string,
    name?: string,
    storage_device_type?: string
  },
  start_time?: string,
  end_time?: string,
  expiry_time?: string,
  backup_type?: string,
  status?: string,
  expired_at?: string,
  message?: string,
  description?: string,
  duration?: string,
  advanced?: {
    force?: boolean
  },
  expiry_days?: number,
  // dbStorage
  subscription_name?: string,
  subscription_id?: string,
  storage_device?: {
    type?: string,
    remote_path?: string,
    version?: string
  },
  created_time?: string,
  phase?: string,

  // dbBackupConfigs
  db_backup_config?: {
    id: string,
    name: string
  },
  manifest?: {
    instance_id?: string,
    db_storage_id?: string,
    db_storage?: {
      id: string,
      name: string
    },
    selected_database?: string,
    expiry_days?: number,
    description?: string,
    advanced?: {
      start?: string,
      end?: string,
      shard?: string,
      retention?: string,
      force?: boolean
    }
  }

  //dbSchedule
  db_schedule?: {
    id: string,
    name: string
  },
  time_description?: string,

  // restore 
  db_restore_id?: string,
  new_database_name?: string,
  restore_duration?: string,
  key: string,
  backup_duration?: string,
  database?: string,
  name: string,
  service_name?: string,
  instance_name?: string,
  backup_name?: string,
  backup_size?: string,
  configuration_name?: string,
  destination_storage_level1?: string,
  backup_destination_storage?: string,
  storage_name?: string,
  storage_type?: string,
  frequency?: string,
  cron_time?: string,
}

export interface table_list_type extends operation_type {
  item_selected?: item_type | undefined;
  dropdown_menus?: dropdown_menu_item[];

  clients?: any[];
  tunnels?: any[];

  client?: string;
  type?: string;
  status?: string;
  backup_type?: string;
  frequency?: string;
  instance_name?: string;
  service_name?: string;
  storage_type?: string;
  subscription_name?: string;
  search_value?: string;
}

export interface dropdown_menu_item {
  list: { name: string; id: string }[] | undefined;
  caption: string;
  value: string | undefined;
  change_event: (event: string) => void;
}

const TableListContext: Context<[table_list_type, React.Dispatch<React.SetStateAction<table_list_type>>]> = React.createContext<
  [table_list_type, React.Dispatch<React.SetStateAction<table_list_type>>]
>([{} as table_list_type, (_value: any) => { }]);

const TableListProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [table_list, set_table_list] = useState({} as table_list_type);
  return <TableListContext.Provider value={[table_list, set_table_list]}>{props.children}</TableListContext.Provider>;
};

export { TableListContext, TableListProvider };
